import CheckoutPage  from "./checkoutPage";

export default CheckoutPage; 